import React, { useEffect, useContext, useState } from 'react';
import { Icon, Button, Form, Input, Message, Modal, Grid, Image, Header } from 'semantic-ui-react'
import useAuth from '../../../hooks/useAuth';
import AuthContext from '../../../context/authContext';
import { ConnectWS } from '../../../ConnectWS'
import { useToasts } from 'react-toast-notifications';
import { Link } from "react-router-dom";
import LogoTeamLigaGenerator from '../../../assets/tglogov6_small.png';


function Registration() {
    const { addToast } = useToasts();
    const [auth, setAuth] = useAuth();// eslint-disable-line no-unused-vars
    const authContext = useContext(AuthContext);
    const [openRegistration, setOpenRegistration] = useState(false)
    const [registrationStatus, setregistrationStatus] = useState(null);
    const [loading, setloading] = useState(false);

    const [form, setForm] = useState({
        name: '',
        surname: '',
        password: '',
        passwordConfirmed: '',
        email: '',
        regulamin: false,
        rodo: false
    });

   

    useEffect(() => {
        if (Number(process.env.REACT_APP_API_DEBUG) === 1) {
            console.log("View: Registration")
        }

        if (authContext.modalInfo && authContext.modalInfo.nameModal === "rejestracja") {
            setregistrationStatus("")
            setOpenRegistration(true)
        }
        return () => { }; // use effect cleanup to set flag false, if unmounted
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const submitLogin = e => {
        e.preventDefault();
        setloading(true)
        setregistrationStatus(null)
        let name = form.name
        let surname = form.surname
        let password = form.password
        let passwordConfirmed = form.passwordConfirmed
        let email = form.email.toLowerCase()
        let regulamin = form.regulamin
       
  

        if (regulamin === false) {

            setregistrationStatus({ value: "Proszę zaznaczyć zapoznanie się z regulaminem oraz z polityką prywatności", error: true, success: false })
            setloading(false)
            return
        }
        
        if (password !== passwordConfirmed) {
            setregistrationStatus({ value: "Wpisane hasła różnią się od siebie", error: true, success: false })
            setloading(false)
            return
        }


        ConnectWS("login/registerAccount", null, { name: name, surname: surname, password: password, email: email, generatorTL:1}, function (response, logout) {

            if (logout === 1) {

            } else if (response && response.status && Number(response.status) === 200) {
                setregistrationStatus({ value: response.data.message, error: false, success: true })
                closeOpenModalR()
                addToast(response.data.message, { appearance: 'success' });

                // setAuth(true, response.data.token, null, null, null, null);
            } else {
                console.log(response.error)
                setregistrationStatus({ value: response, error: true, success: false })
                //addToast(response, { appearance: 'error' });
                //console.log(response);
            }

            setloading(false)
            // closeOpenModalR()

        });


    }


    function closeOpenModalR() {
        setOpenRegistration(false)
        authContext.changeModalInfo(false)
    }

    return (
        <>
            <Modal
                dimmer='blurring'
                closeIcon
                centered={true}
                onClose={() => closeOpenModalR()}
                onOpen={() => setOpenRegistration(true)}
                open={openRegistration}

            >
                <Modal.Header>
                    <Grid stackable>
                        <Grid.Row>
                            <Grid.Column width={12} verticalAlign="middle">
                                <Header as='h2' textAlign='center'>
                                    <Icon name='user' color="red" />
                                    <Header.Content>Rejestracja</Header.Content>
                                </Header>
                            </Grid.Column>
                            <Grid.Column width={4} textAlign="right" only='large screen'>
                                <Image floated='right' size='big' centered src={LogoTeamLigaGenerator} alt="logo"/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>
                <Modal.Content className='modalBGcolor'>
                    <Form onSubmit={submitLogin} size='mini'>
                        <Form.Group widths='equal'>
                            <Form.Field
                                control={Input}
                                required
                                maxLength="25"
                                label='Imię'
                                placeholder='Imię'
                                value={form.name}
                                onChange={(e, data) => setForm({ ...form, name: data.value })}
                            />
                            <Form.Field
                                control={Input}
                                required
                                label='Nazwisko'
                                maxLength="25"
                                placeholder='Nazwisko'
                                value={form.surname}
                                onChange={(e, data) => setForm({ ...form, surname: data.value })}
                            />
                        </Form.Group>
                       
                        <Form.Group widths='equal'>
                           
                            <Form.Field
                                control={Input}
                                required
                                label='E-mail'
                                type="email"
                                placeholder='E-mail'
                                value={form.email}
                                onChange={(e, data) => setForm({ ...form, email: data.value })}
                            />
                        </Form.Group>
                        <Form.Group widths='equal'>
                            <Form.Field
                                control={Input}
                                required
                                label='Hasło (min. 6 znaków)'
                                placeholder='Hasło'
                                type='password'
                                maxLength="25"
                                minLength="6"
                                value={form.password}
                                onChange={(e, data) => setForm({ ...form, password: data.value })}
                            />

                            <Form.Field
                                control={Input}
                                required
                                label='Powtórz Hasło'
                                placeholder='Powtórz Hasło'
                                type='password'
                                maxLength="25"
                                minLength="6"
                                value={form.passwordConfirmed}
                                onChange={(e, data) => setForm({ ...form, passwordConfirmed: data.value })}
                            />
                        </Form.Group>

                        <Form.Group inline>
                            <Form.Checkbox onChange={(e, data) => setForm({ ...form, regulamin: data.checked })} inline required />Rejestrując się akceptujesz <Link to="regulamin" target="_blank" rel="noopener noreferrer" style={{ marginLeft: 5 }}> regulamin</Link> oraz <Link to="polityka-prywatnosci" target="_blank" rel="noopener noreferrer" style={{ marginLeft: 5 }}> polityka prywatności</Link>
                        </Form.Group>
    
                       
                        <Button disabled={form.regulamin === false} fluid color="google plus" loading={loading ? true : false} >REJESTRACJA</Button>
                    </Form>

                    {registrationStatus ? <Message
                        error={registrationStatus.error ? true : false}
                        success={registrationStatus.success ? true : false}
                        content={registrationStatus.value}
                    /> : ''}

                </Modal.Content>

            </Modal>

        </>
    )
}

export default Registration;